// Shared types for the Knowledge Base UI. Mirror the backend KB schemas
// (backend/app/modules/kb/schemas.py). Kept local to the kb/ feature.
export const KIND_LABEL = {
    article: 'Article',
    sop: 'SOP',
    troubleshooting: 'Troubleshooting',
    faq: 'FAQ',
};
export const STATUS_BADGE = {
    draft: 'bg-amber-50 text-amber-700 ring-amber-600/20 dark:bg-amber-950/40 dark:text-amber-300',
    published: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-950/40 dark:text-emerald-300',
    archived: 'bg-slate-100 text-slate-600 ring-slate-500/20 dark:bg-slate-800 dark:text-slate-400',
};
